import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { getNotificationsEnabled, notify, playSound, getUrgentSound, isMuted } from "@/lib/notifications";
import { useAuth } from "@/context/AuthContext";

// Module-level store so previous unread counts survive route remounts.
let prevCounts = null;

export default function NotificationWatcher() {
  const { user } = useAuth();
  const location = useLocation();
  const activeFriendId = location.pathname.startsWith("/app/chat/")
    ? location.pathname.split("/app/chat/")[1]
    : null;
  const activeRef = useRef(activeFriendId);
  activeRef.current = activeFriendId;

  const { data: convos = [] } = useQuery({
    queryKey: ["conversations"],
    queryFn: async () => (await api.get("/conversations")).data,
    refetchInterval: 4000,
    enabled: !!user,
  });

  useEffect(() => {
    const cur = {};
    convos.forEach((c) => {
      cur[c.friend.user_id] = c.unread || 0;
    });

    if (prevCounts && getNotificationsEnabled()) {
      convos.forEach((c) => {
        const before = prevCounts[c.friend.user_id] || 0;
        const now = c.unread || 0;
        if (now > before && c.friend.user_id !== activeRef.current && !isMuted(c.friend.user_id)) {
          const isUrgent = (c.last_message || "").startsWith("⚠️");
          playSound(isUrgent ? getUrgentSound() : "classique");
          notify(c.friend.name || "Nouveau message", c.last_message || "Vous avez un nouveau message");
        }
      });
    }
    prevCounts = cur;
  }, [convos]);

  return null;
}
